import {useRoutes} from "./routes";
import {BrowserRouter as Router} from 'react-router-dom'
import React from "react"

function App() {
  const routes = useRoutes()
  return (
      <Router>
            {routes}
      </Router>
  );
}

export default App;